import React, { Component } from 'react';
import { Container, Row, Col,Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import '../styles/Search.css';
export class Profile extends Component {


  render () {
      return (
          <Container>
              <h3>Supplier Profile</h3>
              <Row>
                  <Col sm={2}>
                      <FontAwesomeIcon icon={faUserCircle} size="4x" alt="User Profile" className="primaryText" />
                  </Col>
                  <Col sm={6}>
                      <Form as={Container}>
                          <Row>
                              <Form.Group as={Col} sm={12} controlId="formName">
                                  <Form.Label>ID</Form.Label>
                                  <p className="profileLable">198568745855 </p>
                              </Form.Group>
                          </Row>
                          <Row>
                              <Form.Group as={Col} sm={12} controlId="formName">
                                  <Form.Label>Name</Form.Label>
                                  <p className="profileLable">Acme Supplier Corp. </p>
                              </Form.Group>
                          </Row>
                          <Row>
                              <Form.Group as={Col} sm={12} controlId="formName">
                                  <Form.Label>Primary Contact</Form.Label>
                                  <p className="profileLable">Emma Supplier</p>
                              </Form.Group>
                          </Row>
                          <Row>
                              <Form.Group as={Col} sm={12} controlId="formName">
                                  <p className="profileLable">emma_supplier@acme.com</p>
                              </Form.Group>
                          </Row>
                    </Form>
                  </Col>
                  <Col m={4}>
                      <h3>Current Users</h3>
                  </Col>
              </Row>
          </Container>
    );
  }
}
